import { serverRegion } from "@utils/env-utils";
import { FlagEuIcon, FlagUsIcon } from "@flat-ui";
/**
 * Hooks that returns everything related to the server the app is running on.
 */
export function useAppServer() {
  return {
    server: serverRegion,
    serverDisplayName: `${serverRegion.toUpperCase()} Server`,
    ServerIcon: serverRegion === "eu" ? FlagEuIcon : FlagUsIcon
  };
}